import React from "react";
import { CARRIERS } from "@/lib/constants";

/**
 * Partner carrier logos. Real brand marks where the user has provided them;
 * clean wordmark SVG fallbacks for the rest. Grayscale → color on hover.
 */
export default function CarrierBanner() {
    const row = [...CARRIERS, ...CARRIERS];
    return (
        <section
            className="border-y border-mm-line bg-white"
            data-testid="carrier-banner"
        >
            <div className="mm-container py-12">
                <div className="mb-8 text-center">
                    <div className="mm-eyebrow mb-2">Trusted carrier partners</div>
                    <h3 className="mm-display text-2xl text-mm-navy sm:text-3xl">
                        We shop across the carriers that fit you best.
                    </h3>
                </div>

                {/* mobile: marquee scroll */}
                <div className="relative overflow-hidden md:hidden">
                    <div className="flex w-max animate-marquee gap-10">
                        {row.map((c, i) => (
                            <CarrierBadge key={`${c.slug}-${i}`} carrier={c} />
                        ))}
                    </div>
                </div>

                {/* desktop: grid, grayscale → color on hover */}
                <div className="hidden md:grid grid-cols-4 gap-6">
                    {CARRIERS.map((c) => (
                        <CarrierBadge key={c.slug} carrier={c} />
                    ))}
                </div>

                <p className="mt-6 text-center mm-disclaimer">
                    Carrier availability varies by state and product. We do not rank
                    carriers publicly and make no guarantee of approval.
                </p>
            </div>
        </section>
    );
}

function CarrierBadge({ carrier }) {
    return (
        <div
            className="mm-carrier-logo flex h-20 w-full min-w-[180px] items-center justify-center rounded-xl px-5"
            data-testid={`carrier-badge-${carrier.slug}`}
            title={carrier.name}
        >
            <img
                src={carrier.logo}
                alt={carrier.name}
                className="max-h-12 max-w-full object-contain object-center"
                loading="lazy"
                width="160"
                height="48"
            />
        </div>
    );
}
